/*
 * @Author: Dong
 * @Date: 2022-05-12 19:11:51
 * @LastEditors: zhang lin
 * @LastEditTime: 2022-12-07 11:27:20
 */
import React from 'react';
import { useIntl } from 'react-intl';
import { Button, Form, Input, Select } from 'sup-ui';
import { WrappedFormUtils } from 'sup-ui/lib/form/Form';
import messages from './messages';
import styles from './index.less';

interface PropsType {
  form: WrappedFormUtils;
  statusOptions: [];
  domainListOptions: [];
  onBtnClick: (type: string) => void;
  onSubmit: () => void;
}

const { Option } = Select;

const FormSearch = (props: PropsType) => {
  const intl = useIntl();
  const { statusOptions, onBtnClick, onSubmit, form, domainListOptions } = props;
  const { getFieldDecorator } = form;

  const handleBtnClick = (type: string) => {
    if (!onBtnClick) return;

    onBtnClick(type);
  };

  return (
    <Form className={styles.form} layout="inline" onSubmit={onSubmit} colon={false}>
      <Form.Item label={intl.formatMessage(messages.status)} colon={false}>
        {getFieldDecorator('status', { initialValue: '' })(
          <Select dropdownMatchSelectWidth={true} style={{ width: 120 }}>
            {statusOptions.map((item: any) => {
              return (
                <Option key={item.name} value={item.value}>
                  {item.name}
                </Option>
              );
            })}
          </Select>,
        )}
      </Form.Item>

      <Form.Item label={intl.formatMessage(messages.domain)} colon={false}>
        {getFieldDecorator('domain')(
          <Select dropdownMatchSelectWidth={true} style={{ width: 120 }}>
            {domainListOptions.map((item: string) => {
              return (
                <Option key={item} value={item}>
                  {item}
                </Option>
              );
            })}
          </Select>,
        )}
      </Form.Item>
      <Form.Item>
        {getFieldDecorator('appName', {
          initialValue: '',
        })(
          <Input
            className={styles.queryInput}
            maxLength={64}
            placeholder={intl.formatMessage(messages.serviceNameTip)}
          />,
        )}
      </Form.Item>
      <Form.Item>
        <Button size="small" htmlType="submit">
          {intl.formatMessage(messages.query)}
        </Button>
      </Form.Item>
      <Form.Item>
        <Button size="small" onClick={() => handleBtnClick('clearForm')}>
          {intl.formatMessage(messages.reset)}
        </Button>
      </Form.Item>
    </Form>
  );
};

export default Form.create()(FormSearch);
